import StackedLineChart from "@/components/LayoutMaps/openLayers/stuff/StackedLineChart";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";
import {mapState} from "vuex";
import Vue from 'vue';
import ComputedStackLineChart from "@/components/LayoutMaps/openLayers/stuff/ComputedStackLineChart";
import ComputedLineChart from "@/components/LayoutMaps/openLayers/stuff/ComputedLineChart";

let h;
export default {
    components: {StackedLineChart, MiniTable, ComputedLineChart, ComputedStackLineChart},
    computed: {
        ...mapState({
            $_showingToast: state => state.customizedDiagram.showingToast,
        })
    },
    mounted() {
        h = this.$createElement;
    },
    methods: {
        _stackedLineChart(data, option) {
            return h(
                StackedLineChart,
                {
                    props: {
                        data: data,
                        title: option.title,
                        xAxis: option.xAxis,
                        id: option.id,
                        enableDynamicStack: true,
                        enableResize: 'vertical'
                    },
                    class: 'w-100',
                    style: 'height: 250px;',
                    on: {
                        stacked: id => {
                            this._hideToast(id);
                        },
                        canceled: id => {
                            this._hideToast(id);
                        }
                    }
                }, []
            )
        },

        _miniTable(data = [], fields = []) {
            let tempList = fields;
            if (fields.length === 0 && data.length > 0) {
                let tempSet = new Set();
                for (let item of data) {
                    if (typeof item === 'object') {
                        for (let key in item) {
                            if (!tempSet.has(key)) {
                                tempSet.add(key);
                            }
                        }
                    }
                }
                tempSet.forEach(o => tempList.push(o));
            }
            return h(
                MiniTable,
                {
                    props: {
                        items: data,
                        fields: tempList,
                        readOnly: true,
                    }
                }, []
            );
        },

        _popupToast(title, vNodes, id) {
            if (this.$_showingToast.has(id)) {
                this._hideToast(id);
            } else {
                let header = h(
                    'div',
                    {class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2']},
                    [h('strong', {class: 'mr-2'}, title)]
                );
                this.$bvToast.toast(vNodes, {
                    id: id,
                    title: [header],
                    solid: true,
                    noAutoHide: true,
                    appendToast: true,
                });
                this.$_showingToast.add(id);
            }
        },

        _hideToast(id) {
            this.$bvToast.hide(id);
            this.$_showingToast.delete(id);
        },

        _generateHTMLDom(vNode) {
            let extend = Vue.extend({
                render: () => vNode,
            });
            let temp = new extend();
            temp.$mount();
            return temp.$el;
        },

        _computedLineChart(nodeId) {
            return h(
                ComputedLineChart,
                {
                    props: {
                        nodeId: nodeId,
                    },
                    class: 'w-100',
                    style: 'height: 250px;',
                    on: {
                        stacked: id => {
                            this._hideToast(id);
                        },
                        canceled: id => {
                            this._hideToast(id);
                        }
                    }
                }, []
            )
        },

        _computedStackLineChart(nodeId, toastId) {
            return h(
                ComputedStackLineChart,
                {
                    props: {
                        nodeId: nodeId,
                        id: toastId,
                        enableDynamicStack: true,
                    },
                    class: 'w-100',
                    on: {
                        stacked: id => {
                            this._hideToast(id);
                        },
                        canceled: id => {
                            this._hideToast(id);
                        }
                    }
                }, []
            )
        },
    }
};
